// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"196":"4b460edf","583":"f25373e4","845":"29156776"}[chunkId] + ".chunk.js");